import { Select } from '@components';
import { useEffect, useState } from 'react';
import { useImpersonation } from '@hooks';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
	ActiveShipper,
	authenticatedUser
} from '@state';
import { SelectOptions } from '@types';
import { useGetCostCentreOptions } from '@api';

export const ShipperCostCenterSelector = () => {
	const authUser = useRecoilValue(authenticatedUser);
	const [shippers, setShippers] = useState<SelectOptions[]>([]);
	const [activeShipper] = useRecoilState(ActiveShipper);
	const { impersonate } = useImpersonation();
	const { callGetCostCentreOpts } = useGetCostCentreOptions();

	useEffect(() => {
		if (authUser?.multipleShippers) {
			callGetCostCentreOpts().then((res) => {
				if (res && res.data) {
					setShippers(res.data.data);
				}
			}).catch((err) => {
				if (err && err.cause) console.log(err);
			});
		}
	}, [authUser]);

	return (
		<>
			{shippers?.length > 0 &&
				<Select
					name={'shipper_id_selector'}
					placeholder={'Please select a shipper'}
					displayThin
					borderless
					value={activeShipper?.id ?? authUser?.shipper?.id}
					onChange={(value: number) => {
						impersonate('shipper', value).then(() => {
							window.location.href = window.location.pathname;
						});
					}}
				>
					{
						shippers?.map((shipper: SelectOptions, index: number) => (
							<Select.Option key={index} value={shipper.value}>
								{shipper.label}
							</Select.Option>)
						)
					}
				</Select>
			}
		</>
	)
}